<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <departments-title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <departments-status-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import DepartmentsTitleCard from '@/views/Defines/Departments/Elements/TitleCard.vue'
import DepartmentsStatusCard from '@/views/Defines/Departments/Elements/StatusCard.vue'

export default {
  name: 'DepartmentsItemForm',
  components: {
    DepartmentsStatusCard,
    DepartmentsTitleCard,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['departments/dataItem']
    },
  },
}
</script>
